import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function EditIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M5 19h1.261L16.498 8.763l-1.261-1.261L5 17.738zm-1.5 1.5v-3.385L16.69 3.931a1.7 1.7 0 0 1 .501-.319 1.5 1.5 0 0 1 .575-.112q.3 0 .583.107.282.106.499.34l1.221 1.236q.233.217.332.5t.099.565q0 .301-.103.576t-.328.501L6.885 20.5zM15.856 8.144l-.62-.642 1.262 1.261z" />
    </Icon>
  );
}

EditIcon.displayName = 'EditIcon';
